import React, { FC, useState } from 'react'
import { Field, useFormikContext } from 'formik'
import { useBreakpoint } from '@mtsbank/ui-kit'
import { PaymentFormValues } from '@entities/payment'
import { useTheme } from '@shared/lib'
import { loginOrEmailErrorGtm, loginOrEmailGtm } from '@shared/lib/gtm'
import { TextField } from '@shared/ui/organisms'
import { Flex, Icon } from '@shared/ui/atoms'
import { Payee } from '@root/api/ump-catalog-manager'
import { SteamTooltip } from './SteamTooltip'
import { SteamTooltipMobile } from './SteamTooltipMobile'

interface SteamLoginFieldProps {
  activeService: Payee
  getCommissions: (baseAmount: number) => void
}

const OldSteamLoginField: FC<SteamLoginFieldProps> = ({ activeService, getCommissions }) => {
  const [openSteam, setOpenSteam] = useState(false)

  const { isMobile } = useBreakpoint()
  const theme = useTheme()

  const { values, setFieldValue, validateForm, handleBlur } = useFormikContext<PaymentFormValues>()

  const handleOpen = () => {
    setOpenSteam(true)
  }

  const handleClose = () => {
    setOpenSteam(false)
  }

  return (
    <Field
      isClearable
      autoComplete="off"
      size="md"
      tooltip={isMobile ? '' : <SteamTooltip />}
      label={
        isMobile ? (
          <Flex alignItems="center">
            Где искать
            <Icon
              onClick={handleOpen}
              icon="baseX16/question-circle"
              color={theme.colors.icon.tertiary}
              style={{ marginLeft: '4px' }}
            />
            <SteamTooltipMobile open={openSteam} handleClose={handleClose} />
          </Flex>
        ) : (
          'Где искать'
        )
      }
      placeholder="Введите логин Steam"
      hint=""
      name="login"
      onChange={(value) => {
        setFieldValue('login', value.target.value)
      }}
      onBlur={async (e: React.FocusEvent<HTMLInputElement>) => {
        const validationErrors = await validateForm()

        if (!validationErrors.login && !validationErrors.price) {
          getCommissions(Number(values.price))
        }

        if (!validationErrors?.login) {
          loginOrEmailGtm(activeService?.providerName)
        } else {
          loginOrEmailErrorGtm(activeService?.providerName)
        }

        handleBlur(e)
      }}
      className="field-input"
      component={TextField}
    />
  )
}

export default OldSteamLoginField
